import { useNavigate } from 'react-router-dom';
import { FiTrash2, FiUsers } from 'react-icons/fi';
import { IoChevronForward } from 'react-icons/io5';
import RefreshButton from '../RefreshButton/RefreshButton';
import './AccountGroupCard.css';

const AccountGroupCard = ({ group, accountCount, onDelete, onRefreshed }) => {
  const navigate = useNavigate();

  return (
    <div className="group-card" onClick={() => navigate(`/groups/${group.id}`)}>
      <div className="group-card-main">
        <div className="group-card-icon">
          <FiUsers />
        </div>
        <div className="group-card-text">
          <h3 className="group-card-title">{group.name}</h3>
          {group.description && (
            <p className="group-card-description">{group.description}</p>
          )}
          <div className="group-card-meta">
            {accountCount} {accountCount === 1 ? 'account' : 'accounts'}
          </div>
        </div>
      </div>
      <div className="group-card-actions" onClick={(e) => e.stopPropagation()}>
        <RefreshButton
          level="group"
          id={group.id}
          onRefreshed={onRefreshed}
          variant="ghost"
          label="Refresh"
        />
        <button
          className="group-card-delete"
          onClick={() => onDelete(group)}
          aria-label="Delete group"
          title="Delete group"
        >
          <FiTrash2 />
        </button>
        <div className="group-card-chevron">
          <IoChevronForward />
        </div>
      </div>
    </div>
  );
};

export default AccountGroupCard;
